/* eslint-disable import/prefer-default-export */

function getFirstUnansweredQuestionIndex(questions) {
  for (let i = 0; i < questions.length; i += 1) {
    if (!questions[i].answered) {
      return i;
    }
  }

  return 0;
}

export { getFirstUnansweredQuestionIndex };
